import { apiProxyRequest as request } from "Api/apiProxyRequest";
import { Settings, SettingsRequest } from "Reducers/environment/service/types";

const buildAutoscalingUrl = (projectId: string, environmentId: string) =>
  `/projects/${encodeURIComponent(projectId)}/environments/${encodeURIComponent(environmentId)}/autoscaling/settings`;

export const getAutoscalingConfiguration = (
  projectId: string,
  environmentId: string
) => request<Settings>(buildAutoscalingUrl(projectId, environmentId), "GET");

export const setAutoscalingConfiguration = (
  projectId: string,
  environmentId: string,
  settings: SettingsRequest
) =>
  request<Settings>(
    buildAutoscalingUrl(projectId, environmentId),
    "PATCH",
    settings
  );
